import React from 'react';
import { ArrowRight, Star } from 'lucide-react';

const Hero = ({ onGetStarted, onContactUs }) => {
  return (
    <section 
      className="section-padding" 
      style={{ 
        background: 'linear-gradient(135deg, rgba(26, 26, 26, 0.85) 0%, rgba(26, 26, 26, 0.75) 100%), url("https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2000")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <div className="luxury-container" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          {/* Badge */}
          <div style={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            gap: '8px',
            background: 'rgba(212, 175, 55, 0.15)',
            border: '1px solid rgba(212, 175, 55, 0.4)',
            padding: '8px 20px',
            marginBottom: '32px',
            borderRadius: '0px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
          }}>
            <Star size={16} fill="var(--accent-gold)" color="var(--accent-gold)" />
            <span style={{ fontSize: '12px', fontWeight: '600', color: 'var(--accent-gold)', letterSpacing: '1px', textTransform: 'uppercase' }}>
              Elite Tax Services
            </span>
          </div>
          
          <h1 className="hero-large" style={{ marginBottom: '24px', color: 'white' }}>
            Professional Tax Preparation Made{' '}
            <span style={{ color: 'var(--accent-gold)', fontWeight: '600' }}>Simple, Secure, and Accurate</span>
          </h1>
          <p className="hero-medium" style={{ marginBottom: '48px', color: 'rgba(255, 255, 255, 0.9)' }}>
            Luxury-level tax services for individuals, self-employed professionals, and small businesses.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn-primary" onClick={onGetStarted}>
              Get Started
              <ArrowRight size={16} />
            </button>
            <button className="btn-primary outline" onClick={onContactUs} style={{ background: 'rgba(255, 255, 255, 0.1)', color: 'white', borderColor: 'white' }}>
              Contact Us
            </button>
          </div>
          <div style={{ 
            marginTop: '80px', 
            paddingTop: '40px', 
            borderTop: '2px solid var(--accent-gold)',
            display: 'inline-block',
            minWidth: '300px'
          }}>
            <p className="body-regular" style={{ 
              color: 'var(--accent-gold)', 
              fontStyle: 'italic', 
              fontWeight: '500',
              fontSize: '16px',
              letterSpacing: '0.5px'
            }}>
              Elite Service. Exceptional Accuracy.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;